import AttendeeSearch from "./attendee_search"

const RegistrationEditModal = {
  initialize() {
    AttendeeSearch.init("edit")
    this.ensureAttenddeTypeSelected()
    return $("#new-attendee-form-js .new-attendee-js select").on("change", function() {
      if ($(this).val() === "") {
        return $("#submit-registration-js").attr("disabled", "disabled")
      } else {
        return $("#submit-registration-js").removeAttr("disabled")
      }
    })
  },

  ensureAttenddeTypeSelected() {
    if (
      $("#new-attendee-form-js .new-attendee-js select")
        .map(function() {
          return $(this).val()
        })
        .toArray()
        .includes("")
    ) {
      return $("#submit-registration-js").attr("disabled", "disabled")
    } else {
      return $("#submit-registration-js").removeAttr("disabled")
    }
  }
}

export default RegistrationEditModal
